import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import Checkbox from '../../Common/Components/Checkbox'
import TextInput from '../../Common/Components/TextInput'
import FormRow from '../../Common/Components/FormRow'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { DisplaySwitching as DisplaySwitchingLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

/**
 * Component properties type.
 */
type Props = {
    includeInTransitioningSequence: boolean
    setIncludeInTransitioningSequence: (checked: boolean) => void
    rptDisplIntervalTime: string
    setRptDisplIntervalTime: (newValue: string) => void
}

/**
 * Automatic report display switching section in Settings tab of report configuration modal window.
 *
 * @param includeInTransitioningSequence
 * @param setIncludeInTransitioningSequence
 * @param rptDisplIntervalTime
 * @param setRptDisplIntervalTime
 */
const DisplaySwitching: React.FC<Props> = ({
    includeInTransitioningSequence,
    setIncludeInTransitioningSequence,
    rptDisplIntervalTime,
    setRptDisplIntervalTime
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('DisplaySwitching')

    return (
        <Fieldset className={'display-switching'}>
            <Heading level={HeadingLevel.ONE}>
                {language.get(DisplaySwitchingLanguage.DisplaySwitching_SectionHeader)}
            </Heading>
            <FormRow isInline className={'include-in-transitioning-sequence'}>
                <Checkbox
                    onChange={setIncludeInTransitioningSequence}
                    isChecked={includeInTransitioningSequence}
                    labelLeft={language.get(DisplaySwitchingLanguage.IncludeintransitioningsequenceLabel)}
                />
            </FormRow>
            <FormRow isInline className={'report-display-interval-time'}>
                <TextInput
                    value={rptDisplIntervalTime}
                    onChange={setRptDisplIntervalTime}
                    labelLeft={language.get(DisplaySwitchingLanguage.RptdisplintervaltimeLabel)}
                    placeholder={language.get(DisplaySwitchingLanguage.RptdisplintervaltimePlaceholder)}
                    disabled={!includeInTransitioningSequence}
                />
            </FormRow>
        </Fieldset>
    )
}

export default DisplaySwitching
